<template>
    <section class="offene-posten-list-container">
        <Pagination
            v-if="pagination.step < items.length"
            :page="pagination.current"
            :length="items.length"
            :perPage="pagination.step"
            :options="paginationQuantity.options"
            @update:page="pagination.current = $event"
            @update:perPage="pagination.step = $event"
        />

        <Table
            bordered
            striped
            small
            showFilter
            tableClass="offene-posten-list"
            :responsive="true"
            :fields="fields"
            :items="items"
            :isBusy="busy"
            :sortBy="sortBy"
            busyText="Lädt offene Posten..."
            emptyText="Keine offenen Posten gefunden"
            :per-page="pagination.step"
            :current-page="pagination.current"
            @sortChanged="pagination.current = 1"
        >
            <template v-slot:head(receiver)>
                Mitglied (ID)<br />Empfänger/Absender
            </template>

            <template v-slot:id="{ row: row }">
                <template v-if="hash">
                    <span
                        class="text-secondary"
                        :ref="hash.replace('#', '')"
                    >
                        {{ row.item.id }}
                    </span>
                </template>
                <template v-else>
                    <span
                        class="text-secondary"
                    >
                        {{ row.item.id }}
                    </span>
                </template>
            </template>

            <template v-slot:detail="{ row: row }">
                <b-button
                    v-if="checkRight('write')"
                    :size="size"
                    variant="secondary"
                    @click="showDetails(row)"
                    class="mv-table-action-btn mr-2 mv-nowrap"
                >
                    Details
                    <font-awesome-icon
                        :icon="
                            row.item._showDetails ? 'caret-down' : 'caret-right'
                        "
                        class="ml-1"
                    />
                </b-button>
                <font-awesome-icon
                    class="text-success guthaben"
                    v-if="row.item.guthaben > 0"
                    icon="euro-sign"
                    v-b-tooltip.hover.top="'aktuelles Guthaben: ' + Number(row.item.guthaben).toLocaleString('de-DE', { style: 'currency', currency: 'EUR'})"
                />
            </template>

            <template v-slot:datum="{ row: row }">
                {{ row.value }}
            </template>

            <template v-slot:receiver="{ row: row }">
                <div class="d-flex align-items-center">
                    <b-link
                        class="text-secondary"
                        @click="
                        setAdditionalFilter(
                            '_mitglied_id',
                            row.item.mitglied_id
                        )
                    "
                    >
                        {{ findMitglied(row.item.mitglied_id) }}
                    </b-link>
                </div>
            </template>

            <template v-slot:einnahmen="{ row: row }">
                <template v-if="row.item.betrag && row.item.betrag >= 0">
                    <template v-if="row.item.storno == 1">
                        <span class="text-secondary">{{
                            currency(row.item.betrag)
                        }}</span>
                    </template>
                    <template v-else>
                        <span class="text-success">{{
                            currency(row.item.betrag)
                        }}</span>
                    </template>
                </template>
            </template>

            <template v-slot:ausgaben="{ row: row }">
                <template v-if="row.item.betrag && row.item.betrag < 0">
                    <template v-if="row.item.storno == 1">
                        <span class="text-secondary">{{
                            currency(row.item.betrag)
                        }}</span>
                    </template>
                    <template v-else>
                        <span class="text-danger">{{
                            currency(row.item.betrag)
                        }}</span>
                    </template>
                </template>
            </template>

            <template v-slot:given="{ row: row }">
                <div
                    v-html="currencyColored(row.value)"
                    class="small"
                ></div>
            </template>

            <template v-slot:diff="{ row: row }">
                <div v-html="currencyColored(row.value)" class="small"></div>
            </template>

            <template v-slot:actions="{ row: row }">
                <b-dropdown
                    text="Aktionen"
                    :size="size"
                    dropleft
                    v-if="row.diff < 0"
                >
                    <b-dropdown-item
                        @click="pushToRoute(row.id, 'buchung')"
                    >
                        offenen Posten verbuchen
                    </b-dropdown-item>
                    <b-dropdown-item
                        v-if="row.guthaben > 0"
                        @click="pushToRoute(row.id, 'guthaben')"
                    >
                        Guthaben verbuchen
                    </b-dropdown-item>
<!--                    <b-dropdown-item-->
<!--                        v-if="row.diff < 0"-->
<!--                    >-->
<!--                        Mahnung erstellen-->
<!--                    </b-dropdown-item>-->
                </b-dropdown>
                <b-dropdown
                    text="Aktionen"
                    :size="size"
                    dropleft
                    v-else
                    disabled
                >
                    <b-dropdown-item
                    >
                        keine Aktionen möglich
                    </b-dropdown-item>
                </b-dropdown>
                <template v-if="checkRight('write') && row.given === '0.00'">
                    <b-button
                        :size="size"
                        variant="link"
                        :to="{ path: `/fibu/offene_posten/${row.id}`}"
                        class="mv-table-action-btn mr-1"
                    >
                        Bearbeiten
                    </b-button>
                </template>
                <template v-else>
                    <b-button
                        disabled
                        :size="size"
                        variant="link"
                        class="mv-table-action-btn mr-1"
                    >
                        Bearbeiten
                    </b-button>
                </template>
                <template v-if="checkRight('delete') && row.given == 0">
                    <b-button
                        :size="size"
                        @click="dataDelete(row)"
                        variant="link"
                        class="text-danger mv-table-action-btn"
                    >Löschen</b-button>
                </template>
                <template v-else>
                    <b-button
                        disabled
                        :size="size"
                        @click="dataDelete(row)"
                        variant="link"
                        class="text-danger mv-table-action-btn"
                    >Löschen</b-button>
                </template>
            </template>

            <template v-slot:row-details="{ row: row }">
                <FiBuOPDetailList
                    :opId="row.item.id"
                    :opItem="row.item"
                />
            </template>
        </Table>
        <RemoveModal
            :title="selected.title"
            :busy="selected.busy"
            @ok="dataProvide"
            @hide="dataHide"
        />
    </section>
</template>

<script>
import CommonView from "@/mixins/CommonView/CommonView";
import Size from "@/mixins/Size/Size";
import Currency from "@/mixins/Currency/Currency";
import { ApiFactory } from "@/api/ApiFactory.js";
import { BlobUtil } from "@/utils/BlobUtil";
import Table from "@/components/Table/Table";
import RemoveModal from "@/components/RemoveModal/RemoveModal";
import FiBuOPDetailList from "../FiBuOPDetailList/FiBuOPDetailList";
import Pagination from "@/components/Pagination/Pagination.vue";
import "./FiBuOPList.scss";

const FiBuOffenePostenApi = ApiFactory.get("fibuOffenePosten");
const FiBuFinanzkontoApi = ApiFactory.get("fibuFinanzkonto");
const FiBuBuchungskontoApi = ApiFactory.get("fibuBuchungskonto");

export default {
    name: "FiBuOPList",
    mixins: [CommonView, Size, Currency],
    components: {
        Table,
        RemoveModal,
        FiBuOPDetailList,
        Pagination
    },
    props: ["filter", "mitglieder", "filterChanged"],
    data() {
        return {
            fields: [
                {
                    key: "id",
                    label: "ID",
                    sortable: true,
                    class: "text-center"
                },
                {
                    key: "detail",
                    label: "Details"
                },
                {
                    key: "datum",
                    label: "Datum",
                    sortable: true,
                    formatter: value => this.$moment(value).format("DD.MM.YYYY")
                },
                {
                    key: "verwendungszweck",
                    label: "Verwendungszweck"
                },
                {
                    key: "receiver",
                    label: "Empfänger",
                    // sortable: true
                },
                {
                    key: "ausgaben",
                    label: "Forderungen",
                    // sortable: true,
                    class: "text-right"
                },
                {
                    key: "given",
                    label: "Beglichen",
                    class: "text-right"
                },
                {
                    key: "diff",
                    label: "Offen",
                    class: "text-right"
                },
                {
                    key: "actions",
                    label: "Funktionen",
                    class: "text-center"
                }
            ],
            api: FiBuOffenePostenApi,
            buchungskontoApi: FiBuBuchungskontoApi,
            finanzkontoApi: FiBuFinanzkontoApi,
            prefetch: false,
            considerDetails: true,
            finanzkonto: {
                busy: false,
                items: [],
                options: []
            },
            buchungskonto: {
                busy: false,
                items: [],
                options: []
            },
            pagination: {},
            paginationQuantity: {
                options: [
                    { items: 10, text: "10" },
                    { items: 15, text: "15" },
                    { items: 20, text: "20" },
                    { items: 25, text: "25" },
                    { items: 30, text: "30" },
                    { items: 35, text: "35" },
                    { items: 40, text: "40" },
                    { items: 45, text: "45" },
                    { items: 50, text: "50" },
                ]
            },
            lSortBy: null,
            sortDesc: false,
            hash: this.$route.hash
        };
    },
    watch: {
        filter: {
            handler(newValue, oldValue) {
                if(oldValue !== null) {
                    this.pagination.current = 1;
                }

                this.fetch();
            }
        },
        pagination: {
            handler() {
                this.$store.dispatch("pages", {
                    fibu_offene_posten: {
                        pagination: this.pagination
                    }
                })
            }
        }
    },
    created() {
        const pages = this.$store.getters.getPages;
        if(pages.fibu_offene_posten) {
            this.pagination = pages.fibu_offene_posten.pagination;
        }

        if (!this.considerDetails) {
            this.fields.splice(1, 1);
        }
        this.fetchFinanzkonto();
        this.fetchBuchungskonto();
        this.findMitglied();
        this.fetch();
    },
    methods: {
        async fetch(busyState = true) {
            if(this.filter?.mahnungen) {
                this.$emit("loadingMahnungen");
            } else {
                this.busy = busyState;
            }

            const response = await this.api.get({
                filter: this.filter
            });
            if (response.ok) {
                if(this.filter?.mahnungen) {
                    BlobUtil.downloadBlob(response.blob, "Mahnung - Offene Posten.pdf");
                } else {
                    var items = response.json.collection;
                    if (items) {
                        items = items.map(item => this.process(item));
                        this.items = items;

                        this.$emit("sums", response.json.totalSums);

                        if(this.hash !== '') {
                            this.$nextTick(function() {
                                const refName = this.hash.replace('#', '');
                                this.scrollToAnchorPoint(refName);
                                this.hash = '';
                            })
                        }

                        this.registerRights(response);
                    } else {
                        this.items = [];
                    }
                }
            } else {
                console.log(response);
            }

            if(this.filter?.mahnungen) {
                this.$emit('mahnungenLoaded');
            } else {
                this.busy = false;
            }
            this.$emit("resetMahnungen");
        },
        async fetchFinanzkonto() {
            this.finanzkonto.busy = true;
            const response = await FiBuFinanzkontoApi.get();
            if (response.ok) {
                this.finanzkonto.items = response.json.collection;
                this.finanzkonto.options = response.json.collection.map(
                    item => {
                        return {
                            text: `${item.kontonr} - ${item.text}`,
                            value: item.id
                        };
                    }
                );
            }
            this.finanzkonto.busy = false;
        },
        async fetchBuchungskonto() {
            this.buchungskonto.busy = true;
            const response = await FiBuBuchungskontoApi.get();
            if (response.ok) {
                this.buchungskonto.items = response.json.collection;
                this.buchungskonto.options = response.json.collection.map(
                    item => {
                        return {
                            text: `${item.kontonr} - ${item.text}`,
                            value: item.id
                        };
                    }
                );
            }
            this.buchungskonto.busy = false;
        },
        process(item) {
            item._showDetails = false;
            return item;
        },
        findMitglied(mitgliedId) {
            const result = this.mitglieder.items.find(
                el => el.id === mitgliedId
            );
            if (result) {
                return `${result.name}, ${result.vorname} (${result.id})`;
            } else {
                return "-";
            }
        },
        setAdditionalFilter(filterType, value) {
            this.$root.$emit("mv::fibu::op::filter::changed", {
                filterType,
                value
            });
        },
        showDetails(row) {
            row.item._showDetails = !row.item._showDetails;
        },
        scrollToAnchorPoint(refName) {
            const el = this.$refs[refName];
            el.scrollIntoView({behaviour: 'smooth', block: 'center'});

            this.$router.replace({
                path: '/fibu/offene_posten'
            })
        },
        pushToRoute(id, route) {
            let routeParam = 'buchung'
            if (route !== routeParam) {
                routeParam = 'guthaben';
            }
            let index = this.items.findIndex(item => item.id === id);


            let nextRowId = '';
            if (this.filter.closed === '0' || this.filter.closed === 0) {
                if (this.items.at(index + 1)) {
                    nextRowId = `#${this.items.at(index + 1).id}`;
                } else if (index > 0 && this.items.at(index - 1)) {
                    nextRowId = `#${this.items.at(index - 1).id}`;
                }
            }

            this.$router.push({
                path: `/fibu/offene_posten/${id}/${routeParam}`,
                hash: nextRowId
            });
        }
    },
    computed: {
        sortBy() {
            return this.lSortBy
                ? this.lSortBy
                : this.filter
                    ? this.filter.orderby
                    : null;
        }
    }
};
</script>
